import { Grid, Typography } from '@mui/material'
import React from 'react'

const QuantityError = ({ quantityError }) => {
  return <Grid item>{quantityError && <Typography style={{ color: 'red' }}>{quantityError}</Typography>}</Grid>
}

export default QuantityError
